import { Injectable } from '@angular/core'
import { ApiService } from '@app/shared/services/api.service'
import { removeLocalVars } from '@app/shared/utils/arr.util'
import { ShopInvoicePayload, ShopQuickBooksCustomerChange } from '@app/shop/models/shopOrderAccount.model'

@Injectable({
  providedIn: 'root'
})
export class ShopOrderService {
  path = '/shop-orders'

  constructor(private apiService: ApiService) { }

  /* get = (_id: string, queryParams?: any) =>
    this.apiService.get(`${this.path}/${_id}`, queryParams) */

  getAll = query => this.apiService.get(this.path, removeLocalVars({ ...query }))

  getOne = query => this.apiService.get(`${this.path}/${query._id}`, removeLocalVars({ ...query }))

  save = (query) => this.apiService.post(`${this.path}`, removeLocalVars({ ...query }))

  createFromExpense = (expenseId) => this.apiService.post(`${this.path}/expense/${expenseId}`)

  update = query => this.apiService.patch(`${this.path}/${query.order._id}`, { order: removeLocalVars({ ...query.order }), populate: query.populate })

  delete = query => this.apiService.delete(`${this.path}/${query._id}`)

  getShopOrderPDF = (order_id, query) => this.apiService.getPdf(`${this.path}/${order_id}/pdf`, query)

  restoreMany = (ids: string[]) => this.apiService.post(this.path + `/restoreMany`, { ids })

  getAccounts = (shopOrderId: string) => this.apiService.get(`${this.path}/${shopOrderId}/accounts`)

  // Shop QuickBooks item catalog (local copy) for the part picker: one page of the search for `search`
  // (name, part number, description), or with `ids` just those items
  getQuickBooksCatalog = (query: { search?: string, skip?: number, limit?: number, types?: string, ids?: string } = {}) =>
    this.apiService.get(`${this.path}/quickbooks/catalog`, query)

  // One catalog item re-read from QuickBooks (current price); data is null when QuickBooks no longer has it
  getQuickBooksCatalogItem = (qbId: string) => this.apiService.get(`${this.path}/quickbooks/catalog/${qbId}`)

  getInvoiceForm = (shopOrderId: string, accountId?: string) =>
    this.apiService.get(`${this.path}/${shopOrderId}/accounts/invoice/form`, { accountId })

  createInvoice = (shopOrderId: string, invoice: ShopInvoicePayload) =>
    this.apiService.post(`${this.path}/${shopOrderId}/accounts/invoice`, invoice)

  updateInvoice = (shopOrderId: string, accountId: string, invoice: ShopInvoicePayload) =>
    this.apiService.put(`${this.path}/${shopOrderId}/accounts/${accountId}/invoice`, invoice)

  // Deletes it in QuickBooks too; its services can then be invoiced again
  deleteInvoice = (shopOrderId: string, accountId: string) =>
    this.apiService.delete(`${this.path}/${shopOrderId}/accounts/${accountId}/invoice`)

  // Re-read the invoice from QuickBooks: { account }, or { accountId, deleted: true, accounting } when it's gone there
  syncInvoice = (shopOrderId: string, accountId: string) =>
    this.apiService.post(`${this.path}/${shopOrderId}/accounts/${accountId}/sync`, {})

  // Default term of the order customer's shop invoices; empty clears it
  setCustomerTerm = (shopOrderId: string, salesTermId: string) =>
    this.apiService.put(`${this.path}/${shopOrderId}/accounts/customer/term`, { salesTermId: salesTermId || null })

  // The shop QuickBooks customer of the order's truck; each call answers with the new link
  changeQuickBooksCustomer = (shopOrderId: string, change: ShopQuickBooksCustomerChange) => {
    const url = `${this.path}/${shopOrderId}/accounts/customer`
    return change.type === 'link' ? this.apiService.put(url, { qbCustomerId: change.qbCustomerId }) : this.apiService.delete(url)
  }
}
